/**
 * Anzeige-Konstanten für den GOLD-Code. Die verbindliche Wirkung liegt im Backend
 * (`self-checkout/meta/config/self-checkout-codes.config.ts`) - hier steht nur, was der Kunde sieht.
 */

export const GOLD_DISCOUNT_HINT = '-1.000€ Rabatt auf den ersten Monat der Zusammenarbeit';

export const GOLD_BADGE_TEXT = 'GOLD-Code aktiv';

export const GOLD_BADGE_GRADIENT = 'linear-gradient(179deg, #f4da7c 0%, #e6c158 28%, #d8b043 50%, #e4c057 72%, #d1a636 100%)';

export const GOLD_ACCENT_COLOR = '#efdd7c';
export const GOLD_FIRST_MONTH_DISCOUNT = 1000;
